import React, { useRef } from "react";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";

// import styles from "./Features.module.sass";
import HeroRapports from "./HeroRapports";
import FonctionnalitesContrat from "./FonctionnalitesContrat";
import AvantagesGestion from "./AvantageGestion";  
import SolutionEmargement from "./SolutionEmargement";
import ExportEmargement from "./ExportEmargement";
import Faq from "./Faq";

const Rapports = () => {
  const scrollToRef = useRef(null);

  const seoData = {
    title: "Rapports & Statistiques - Analytics avancés pour CFA | Edutio",
    description: "Générez des rapports détaillés et analysez les performances de votre CFA avec Edutio. Tableaux de bord en temps réel, KPI personnalisés et analytics formation.",
    keywords: "rapports CFA, statistiques formation, analytics CFA, tableaux de bord, KPI formation professionnelle, business intelligence"
  };

  return (
    <>
      <SEOHead {...seoData} />
      <HeroRapports  scrollToRef={scrollToRef} />
      <AvantagesGestion  className="section-pb" scrollToRef={scrollToRef} />
      <SolutionEmargement />
      <ExportEmargement />
      <FonctionnalitesContrat />
      <Faq />
      <AppelAction className="section" />
    </>
  );
};

export default Rapports;
